function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333331;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dark_Grey_Shizzz",
  "data-name": "Dark Grey Shizzz"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M4.89,99.35C36.57,105.51,62.17,50.06,123,61.89s63.45,72.78,95.42,79l-2.45,12.56-16.84-3.28c-21.74-14.6-38.25-63.73-79.36-71.72C78.36,70.39,44.63,109.75,19,115.13c21.75,14.6,38.25,63.73,79.64,71.78,41.1,8,74.83-31.36,100.46-36.74l16.84,3.28L213.5,166c-32-6.22-57.28,49.28-118.08,37.45S31.68,130.63,0,124.47ZM56.21,0,82.47,38.61l-13.7,9.48L42.51,9.5Zm18,125c3.67-18.84,22.37-31.2,41.2-27.53A34.89,34.89,0,1,1,102.12,166C83.29,162.3,70.59,143.83,74.25,125Zm31,25a18.8,18.8,0,0,0,22.11-14.66c1.95-10-4.78-19.59-15-21.59a18.5,18.5,0,0,0-21.77,14.43A18.74,18.74,0,0,0,105.23,150Zm12.06-104.6L126.12,0l16.27,3.17-8.83,45.38Zm90.31-15L216.8,44,178,69.93l-9.19-13.64Z"
})));

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 218.39 205.12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Eye.f3db5529.svg";
export { ForwardRef as ReactComponent };